import React, { useState } from 'react';
import { Plus, FileText, CheckSquare, StickyNote, Calendar, X, FolderOpen } from 'lucide-react';
import { Button } from './ui/button';

const FAB_ITEMS = [
  { id: 'datos', icon: FolderOpen, label: 'Datos expediente', color: 'bg-slate-700 hover:bg-slate-800' },
  { id: 'actuacion', icon: FileText, label: 'Actuación', color: 'bg-blue-600 hover:bg-blue-700' },
  { id: 'tarea', icon: CheckSquare, label: 'Tarea', color: 'bg-green-600 hover:bg-green-700' },
  { id: 'nota', icon: StickyNote, label: 'Nota', color: 'bg-yellow-500 hover:bg-yellow-600' },
  { id: 'evento', icon: Calendar, label: 'Evento', color: 'bg-purple-600 hover:bg-purple-700' },
];

const FloatingActionButton = ({ onAction }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAction = (actionId) => {
    setIsOpen(false);
    onAction(actionId);
  };

  return (
    <div className="fixed left-6 bottom-6 z-50 flex flex-col-reverse items-start gap-2">
      {/* Sub-botones */}
      {isOpen && (
        <div className="flex flex-col gap-2 mb-2 animate-in slide-in-from-bottom-2 duration-200">
          {FAB_ITEMS.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={item.id} 
                className="flex items-center gap-2"
                style={{ animationDelay: `${index * 50}ms` }}
              >
                <Button
                  onClick={() => handleAction(item.id)}
                  className={`w-12 h-12 rounded-full ${item.color} text-white shadow-lg hover:shadow-xl transition-all`}
                >
                  <Icon className="w-5 h-5" />
                </Button>
                <span className="bg-gray-900 text-white text-sm px-3 py-1 rounded shadow-lg whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {/* Botón principal */}
      <Button
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg hover:shadow-xl transition-all ${
          isOpen 
            ? 'bg-gray-700 hover:bg-gray-800 rotate-45' 
            : 'bg-blue-700 hover:bg-blue-800'
        }`}
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white transition-transform" />
        ) : (
          <Plus className="w-6 h-6 text-white transition-transform" />
        )}
      </Button>
    </div>
  );
};

export default FloatingActionButton;
